// extracted by mini-css-extract-plugin
module.exports = {"file":"FileOption_file__2sRBc","hidden":"FileOption_hidden__OyRtZ","filename":"FileOption_filename__MBigH"};